<div class="nav ">
  <div [ngStyle]="getContainerStyle()" [ngClass]="getContainerClass()">

    @if (!isAuthenticated) {
    <a class="brand-lockup" routerLink="/" [attr.aria-label]="currentLang === 'ar' ? 'مطار الشارقة' : 'Sharjah Airport'">
      <img src="assets/images/sharjah-airport-logo.svg" alt="Sharjah Airport" class="nav-logo">
    </a>
    }

    @if(isAuthenticated){

    <a class="cursor-pointer nav-link-item" [routerLink]="['/strategic-knowledge-library']">
      {{ 'strategic_knowledge_library' | translate }}
    </a>

    <div class="nav-toolbar-end">
      <div class="flex align-items-center" style="position: relative;">
        <div (click)="toggoleUserListInfo() " style="border:1px var(--primary-dark-color) solid"
          class=" w-3rem h-3rem g-bg-primary-dark border-circle shadow-3 border-1 flex align-items-center justify-content-center cursor-pointer overflow-hidden">
          <img src="assets/images/avatar.png" alt="User Avatar" style="width: 100%; height: 100%; object-fit: cover;">
        </div>
        @if(ListInfo){
        <ul class="account-menu shadow-2 cursor-pointer w-10rem">
          <li [routerLink]="['profile']">
            {{'profile'|translate}}
          </li>
          <li (click)="logOut()" class="flex align-items-center">
            {{'logout'|translate}} <i class="mx-2 pi pi-sign-out"></i>
          </li>
        </ul>
        }
      </div>

      <div class="flex align-items-center" style="position: relative;">
        <div (click)="allNotifications()">
          <i class="fa-solid fa-bell cursor-pointer" pBadge
            style="font-size:2rem" [value]="unreadCount.toString()"></i>
        </div>
      </div>

      <div class="flex align-items-center" style="position: relative;">
        <button (click)="toggleLanguageButton()" class="language-btn"
          [attr.aria-label]="currentLang === 'ar' ? 'Switch to English' : 'Switch to Arabic'">
          <i class="pi pi-globe"></i>
          <span class="btn-text">{{ currentLang === 'ar' ? 'EN' : 'عربي' }}</span>
        </button>
      </div>
    </div>
    }
    @else {
    <div class="nav-toolbar-end">
      <button (click)="toggleLanguageButton()" class="language-btn"
        [attr.aria-label]="currentLang === 'ar' ? 'Switch to English' : 'Switch to Arabic'">
        <i class="pi pi-globe"></i>
        <span class="btn-text">{{ currentLang === 'ar' ? 'EN' : 'عربي' }}</span>
      </button>
    </div>

    }

  </div>
  @if(progress<100){ <div class="progress-container" dir="ltr">
    <div class="progress-bar" [style.width.%]="progress"></div>
</div>
}
</div>